var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoundLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#EFF0F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 23C8.70833 23 8.31597 22.8368 7.98958 22.5104C7.66319 22.184 7.5 21.7917 7.5 21.3333V9.66667C7.5 9.20833 7.66319 8.81597 7.98958 8.48958C8.31597 8.16319 8.70833 8 9.16667 8H15V9.66667H9.16667V21.3333H15V23H9.16667ZM18.3333 19.6667L17.1875 18.4583L19.3125 16.3333H12.5V14.6667H19.3125L17.1875 12.5417L18.3333 11.3333L22.5 15.5L18.3333 19.6667Z",
    fill: "#102486"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundLogout);
export default __webpack_public_path__ + "static/media/round-logout.7dc700a4492853516be3c0607d336d2f.svg";
export { ForwardRef as ReactComponent };